import { useEffect, useCallback } from "react";

export const useGazeData = (callback, enabled = true) => {
  const handleGazeData = useCallback(
    (event) => {
      // Normalize event structure
      // Previous implementation had data in event.detail.data
      // Newer implementations have it directly in event.detail
      const normalizedData = event.detail.data || event.detail || {};
      callback?.(normalizedData);
    },
    [callback],
  );

  const GazeApi = {
    oldPegasusApi: {
      subscribeToGazeData: () => {
        window.pegasus.subscribeToGazeData();
        window.addEventListener("gaze-data", handleGazeData);
      },
      unsubscribeToGazeData: () => {
        window.pegasus.unsubscribeToGazeData();
        window.removeEventListener("gaze-data", handleGazeData);
      },
    },
    latestApi: {
      subscribeToGazeData: () => {
        window.eyeTracking?.addEventListener("gaze-data", handleGazeData);
      },
      unsubscribeFromGazeData: () => {
        window.eyeTracking?.removeEventListener("gaze-data", handleGazeData);
      },
    },
  };

  useEffect(() => {
    if (!enabled) return;

    const subscribeToGazeData = Boolean(window.eyeTracking?.addEventListener)
      ? GazeApi.latestApi.subscribeToGazeData
      : GazeApi.oldPegasusApi.subscribeToGazeData;

    const unsubscribeFromGazeData = Boolean(window.eyeTracking?.addEventListener)
      ? GazeApi.latestApi.unsubscribeFromGazeData
      : GazeApi.oldPegasusApi.unsubscribeToGazeData;

    try {
      if (typeof subscribeToGazeData !== "function") {
        console.warn("subscribeToGazeData is not a function");
        return;
      }
      if (typeof unsubscribeFromGazeData !== "function") {
        console.warn("unsubscribeFromGazeData is not a function");
        return;
      }

      subscribeToGazeData();

      return () => {
        try {
          unsubscribeFromGazeData();
        } catch (error) {
          console.error("Error during cleanup of gaze data subscription:", error);
        }
      };
    } catch (error) {
      console.error("Error setting up gaze data subscription:", error);
    }
  }, [
    handleGazeData,
    enabled,
    GazeApi.oldPegasusApi.subscribeToGazeData,
    GazeApi.oldPegasusApi.unsubscribeToGazeData,
    GazeApi.latestApi.subscribeToGazeData,
    GazeApi.latestApi.unsubscribeFromGazeData,
  ]);
};
